import Vue from 'vue';
import Router from 'vue-router';
import toKebab from 'just-kebab-case';

import app from '@/components/app';
import list from '@/components/list';
import signIn from '@/components/sign-in';
import study from '@/components/study';
import api from '@/api';
import store from '@/store';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/app',
    },
    {
      path: '/login',
      component: signIn,
      name: 'SignIn',
    },
    {
      component: app,
      name: 'App',
      path: '/app',
      redirect: { name: 'StudyList' },
      children: [
        {
          component: list,
          meta: { auth: true },
          name: 'StudyList',
          path: 'list',
        },
        {
          component: study,
          meta: { auth: true },
          name: 'NewStudy',
          path: 'study',
          children: [
            {
              component: study,
              meta: { auth: true },
              name: 'EditStudy',
              path: ':id',
            },
          ],
        },
      ],
    },
  ],
});

router.afterEach(({ name }) => store.commit('setSection', toKebab(name)));

router.beforeEach(async (to, from, next) => {
  if (to.meta.auth) {
    return api.authenticate()
      .then(({ accessToken }) => {
        store.commit('auth/setAccessToken', accessToken);
        return api.passport.verifyJWT(accessToken);
      })
      .then((token) => {
        store.dispatch('auth/populateUser', token.userId);
        next();
      })
      .catch(() => router.replace({ name: 'SignIn' }));
  }

  if (to.name === 'SignIn' && store.state.auth.accessToken) {
    return router.replace({ name: 'App' });
  }

  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js